export default function PaypalCancel() {
  if (typeof window !== "undefined") {
    const u = new URL("/", window.location.origin);
    u.searchParams.set("cancel", "1");
    window.location.replace(u.toString());
  }
  return null;
}
